export { default } from './list.component';
